import ButtonDestructive from '@/app/shared_components/buttons/ButtonDestructive.vue';
import ButtonLight from '@/app/shared_components/buttons/ButtonLight.vue';
import ButtonLink from '@/app/shared_components/buttons/ButtonLink.vue';
import ButtonPrimary from '@/app/shared_components/buttons/ButtonPrimary.vue';
import ButtonSecondary from '@/app/shared_components/buttons/ButtonSecondary.vue';
import ButtonTertiary from '@/app/shared_components/buttons/ButtonTertiary.vue';
import ButtonCollapseToggle from '@/app/shared_components/buttons/ButtonCollapseToggle.vue';
import ButtonUpsell from '@/app/shared_components/buttons/ButtonUpsell.vue';

export default {
  install(Vue) {
    Vue.component('ButtonDestructive', ButtonDestructive);
    Vue.component('ButtonLight', ButtonLight);
    Vue.component('ButtonLink', ButtonLink);
    Vue.component('ButtonPrimary', ButtonPrimary);
    Vue.component('ButtonSecondary', ButtonSecondary);
    Vue.component('ButtonTertiary', ButtonTertiary);
    Vue.component('ButtonCollapseToggle', ButtonCollapseToggle);
    Vue.component('ButtonUpsell', ButtonUpsell);
  },
};
